import {
    FormElementInput,
    FormFileAttachmentInput,
} from '~graphql/generated/graphql'

export function isFormFileAttachment(
    attachment: FormFileAttachmentInput | undefined,
): attachment is FormFileAttachmentInput {
    return !!attachment?.url
}

export function getFormFileAttachments(
    element: Pick<FormElementInput, 'attachments' | 'value'>,
): FormFileAttachmentInput[] {
    const attachments = [
        ...(element.attachments || []),
        ...parseFormFileAttachmentValue(element.value),
    ].filter(isFormFileAttachment)

    return attachments.filter(
        (attachment, index) =>
            attachments.findIndex(
                existingAttachment => existingAttachment.url === attachment.url,
            ) === index,
    )
}

function parseFormFileAttachmentValue(
    value: string | null | undefined,
): FormFileAttachmentInput[] {
    if (!value?.trim()) {
        return []
    }

    try {
        const parsed: unknown = JSON.parse(value)
        if (Array.isArray(parsed)) {
            return parsed.flatMap(parseUnknownAttachment)
        }

        return parseUnknownAttachment(parsed)
    } catch {
        return [{ url: value }]
    }
}

function parseUnknownAttachment(value: unknown): FormFileAttachmentInput[] {
    if (typeof value === 'string') {
        return [{ url: value }]
    }

    if (!value || typeof value !== 'object' || !('url' in value)) {
        return []
    }

    const attachment = value as Record<string, unknown>
    const url = attachment.url

    if (typeof url !== 'string' || !url) {
        return []
    }

    return [
        {
            id:
                typeof attachment.id === 'string'
                    ? attachment.id
                    : undefined,
            filename:
                typeof attachment.filename === 'string'
                    ? attachment.filename
                    : undefined,
            mime_type:
                typeof attachment.mime_type === 'string'
                    ? attachment.mime_type
                    : undefined,
            size_bytes:
                typeof attachment.size_bytes === 'number'
                    ? attachment.size_bytes
                    : undefined,
            thumbnail_url:
                typeof attachment.thumbnail_url === 'string'
                    ? attachment.thumbnail_url
                    : undefined,
            url,
        },
    ]
}
